/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BulkTagRemediationStatusRequest {
    getFixupPrototypeFunction() { return BulkTagRemediationStatusRequest.fixupPrototype; }

    static newInstance(model: Partial<BulkTagRemediationStatusRequest>): BulkTagRemediationStatusRequest {
        let obj = Object.assign(new BulkTagRemediationStatusRequest(), model);
        BulkTagRemediationStatusRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BulkTagRemediationStatusRequest>): BulkTagRemediationStatusRequest {
        if (!model) return null;
        return BulkTagRemediationStatusRequest.newInstance(<BulkTagRemediationStatusRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BulkTagRemediationStatusRequest) {
        if (!obj) return;

        models.BulkTagRemediationStatusRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BulkTagRemediationStatusRequest): boolean {
        Object.setPrototypeOf(obj, BulkTagRemediationStatusRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Service Account Id
     */
    service_account_id: string;

    /**
     * Tag Remediation Resource Ids
     */
    resource_ids: Array<string>;

}
